export default __webpack_public_path__ + "static/media/ProfileUnknow.5aeaa632.svg";